import type { InjectionKey, Ref } from 'vue'

import type { SuggesterUserSession } from '../useNotificationsWebsocket/types'

export const DelphiSessionKey: InjectionKey<{
  delphiSession: Ref<SuggesterUserSession | undefined>
  setDelphiSession: (value?: SuggesterUserSession) => void
}> = Symbol('DelphiSession')
